import { Reveal } from "./Reveal";
import { SERVICE_GROUPS } from "../../data";

export const Services = () => (
  <section id="services" className="py-24 sm:py-36 bg-[#EBE7DB]">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16 sm:mb-24">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] text-[#7A766C] mb-6">— The Menu</p>
          <h2 className="font-serif font-light text-4xl sm:text-6xl lg:text-7xl tracking-tight text-[#1A1A18]">
            Treatments <span className="italic">&amp; pricing</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-[#4A4843] max-w-xs text-sm leading-relaxed">
            Every service begins with a short consultation. Prices are a guide — your plan is
            tailored on the day.
          </p>
        </Reveal>
      </div>

      <div className="space-y-20">
        {SERVICE_GROUPS.map((group) => (
          <div key={group.key} data-testid={`service-group-${group.key}`}>
            <Reveal>
              <div className="mb-8 pb-4 border-b border-[#C9C2B1]">
                <h3 className="font-bodoni text-sm uppercase tracking-[0.2em] text-[#3E3B32]">
                  {group.label}
                </h3>
                {group.sublabel && (
                  <p className="font-serif italic text-lg text-[#7A766C] mt-2">{group.sublabel}</p>
                )}
              </div>
            </Reveal>
            <div>
              {group.items.map((item, i) => (
                <Reveal key={item.name} delay={i * 0.04}>
                  <div
                    className="group grid grid-cols-12 gap-3 sm:gap-6 items-baseline py-6 border-b border-[#D5CFC1] hover:bg-[#F8F6F0]/60 transition-colors duration-300 px-2 -mx-2 rounded-lg"
                    data-testid="service-item"
                  >
                    <div className="col-span-8 sm:col-span-9">
                      <h4 className="font-serif text-2xl sm:text-3xl text-[#1A1A18] group-hover:translate-x-1 transition-transform duration-300">
                        {item.name}
                      </h4>
                      <p className="text-sm text-[#7A766C] mt-1">
                        {item.desc}
                        {item.time && (
                          <span className="ml-2 text-[#3E3B32]">· {item.time}</span>
                        )}
                      </p>
                    </div>
                    <div className="col-span-4 sm:col-span-3 text-right font-serif text-2xl sm:text-3xl text-[#3E3B32]">
                      {item.price}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
